import React from 'react';
import { m } from 'framer-motion';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Image from 'src/components/image';
import { varFade, MotionViewport } from 'src/components/animate';
import Carousel, { useCarousel, CarouselArrows } from 'src/components/carousel';

// ----------------------------------------------------------------------

export default function AboutTeam() {
  const TeamImages = [
    '/assets/teamphoto/team_2.png',
    '/assets/teamphoto/team_3.jpg',
    '/assets/teamphoto/team_4.jpg',
    '/assets/teamphoto/team_1.jpg',
    '/assets/teamphoto/team_5.jpg',
    '/assets/teamphoto/team_6.jpg',
    '/assets/teamphoto/team_7.jpg',
  ];
  const carousel = useCarousel({
    infinite: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 1279,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 959,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  });

  return (
    <Container component={MotionViewport} sx={{ textAlign: 'center', py: { xs: 10, md: 15 } }}>
      <m.div variants={varFade().inDown}>
        <Typography variant="overline" sx={{ color: 'text.disabled' }}>
          The people I’ve worked with
        </Typography>
      </m.div>

      <m.div variants={varFade().inUp}>
        <Typography variant="h2" sx={{ my: 3 }}>
          Teams & Colleagues
        </Typography>
      </m.div>

      <m.div variants={varFade().inUp}>
        <Typography
          sx={{
            mx: 'auto',
            maxWidth: 800,
            color: 'text.secondary',
            textAlign: { xs: 'justify', md: 'center' },
          }}
        >
          Over the last 4+ years, I’ve had the opportunity to work with talented designers,
          developers, managers, and stakeholders across different teams. These moments reflect
          collaboration, learning, and shared success.
        </Typography>
      </m.div>

      <Box sx={{ position: 'relative' }}>
        <CarouselArrows
          filled
          shape="rounded"
          onNext={carousel.onNext}
          onPrev={carousel.onPrev}
          leftButtonProps={{
            sx: {
              left: 24,
              ...(TeamImages.length < 5 && { display: 'none' }),
            },
          }}
          rightButtonProps={{
            sx: {
              right: 24,
              ...(TeamImages.length < 5 && { display: 'none' }),
            },
          }}
        >
          <Carousel ref={carousel.carouselRef} {...carousel.carouselSettings}>
            {TeamImages.map((member, index) => (
              <Box
                key={index}
                component={m.div}
                variants={varFade().in}
                sx={{
                  px: 1.5,
                  py: { xs: 8, md: 10 },
                }}
              >
                <MemberCard member={member} />
              </Box>
            ))}
          </Carousel>
        </CarouselArrows>
      </Box>
    </Container>
  );
}

// ----------------------------------------------------------------------

function MemberCard({ member }) {
  return (
    <Card>
      <Box sx={{ px: 1, mt: 2.5, mb: 2.5 }}>
        <Image alt={member} src={member} ratio="1/1" sx={{ borderRadius: 2 }} />
      </Box>
    </Card>
  );
}

MemberCard.propTypes = {
  member: PropTypes.string,
};
